import React, { useContext, useState } from 'react'
import { Helmet } from "react-helmet";
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

import TreatmentGallery from '../components/TreatmentGallery'

import { AppStateContext } from '../AppStateContext';


const Treatments = () => {

    // PAGE TITLE
    const pageTitle = 'DT. Yeşim Alkan | Tedaviler '
    const metaDescription = "DT. Yeşim Alkan'ın sunmuş olduğu çeşitli diş tedavileri. Diş sağlığınızı geliştirmek için hizmetlerimizi inceleyin. İletişim için bize ulaşın."

    const { language, setLanguage } = useContext(AppStateContext);

    const translations = {
        tr: {
            banner1text1: 'Tedaviler',
        },
        en: {
            banner1text1: 'Services',
        },
        it: {
            banner1text1: 'Trattamenti',
        },
    };

    const getText = (key) => {
        return translations[language][key] // Default to the provided key if translation is not found
    };

    const handleNavigation = (path) => {
        window.scrollTo(0, 0);
        window.location.href = path;
    }

    return (
        <div>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={metaDescription} />
                <link rel="canonical" href="http://dtyesimalkan.com/treatments" />
            </Helmet>
            <Navbar />
            <div className='h-[120px] w-full'></div>
            <div className='bg-slate-50'>
                <div className='max-w-screen-xl m-auto w-full md:py-20 p-5 '>
                    <div className='text-xl md:text-2xl text-[#6DA5C0] text-start md:text-center'>Dt. Yesim Alkan</div>
                    <div className='text-4xl text-start md:text-center pt-2 text-[#0F969C] font-bold'>{getText('banner1text1')}</div>
                    <TreatmentGallery />
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Treatments